//
//
//
//
//
//
var script = {
  name: 'IssueStatusRenderer',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusName() {
      return this.value && this.value.name;
    },

    statusColor() {
      return this.value && this.value.statusCategory && this.value.statusCategory.colorName;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/IssueStatusRenderer.vue_rollup-plugin-vue=script.js